import type { TTagVariant } from '@crehana/compass.ui/v3/tag';

import { TimeOvertimeRequestStatus } from '@/generated/graphql/types';

import type { TKeys } from './i18n/types';

export const PAGE_SIZE = 8;
export const PAGE_SIZES = [8, 25, 50];

// Shared by the requests table row Tag and the drawer Tag, so a status
// change reads the same everywhere. CANCELLED never reaches this screen
// (RN-SOL-23); it maps to PENDING only to keep the Record exhaustive over
// the wire enum.
export const STATUS_CONFIG: Record<
  TimeOvertimeRequestStatus,
  { tKey: TKeys; variant: TTagVariant }
> = {
  [TimeOvertimeRequestStatus.Pending]: {
    tKey: 'STATUS_PENDING',
    variant: 'primary',
  },
  [TimeOvertimeRequestStatus.Approved]: {
    tKey: 'STATUS_APPROVED',
    variant: 'success',
  },
  [TimeOvertimeRequestStatus.Denied]: {
    tKey: 'STATUS_DENIED',
    variant: 'alert',
  },
  [TimeOvertimeRequestStatus.Cancelled]: {
    tKey: 'STATUS_PENDING',
    variant: 'primary',
  },
};
